import { Handler } from "../chain/TransformServiceHandlerChain";
import { CustomApiTransformError } from "../error/CustomApiTransformError";
export class StreamHandler extends Handler {
    async process(request) {
        if (request.isStream) {
            const stream = request.stream();
            if (!stream) {
                throw CustomApiTransformError.default;
            }
            request.setResult(stream);
            return true;
        }
        return false;
    }
}
